import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDemo } from "@/store/DemoContext";
import { HowScoringModal } from "./HowScoringModal";
import { HelpCircle, Goal } from "lucide-react";

export function AppNav() {
  const { t } = useTranslation();
  const { state } = useDemo();
  const [howOpen, setHowOpen] = useState(false);

  const links = [
    { to: "/", label: t("nav.home"), end: true, testid: "nav-home" },
    { to: "/season", label: t("nav.season"), testid: "nav-season" },
    { to: "/leaderboard", label: t("nav.leaderboard"), testid: "nav-leaderboard" },
    { to: "/profile", label: t("nav.profile"), testid: "nav-profile" },
  ];

  const profileLabel = state.profileId === "new" ? t("demo.newUser") : state.profileId === "elite" ? t("demo.eliteUser") : t("demo.midUser");

  return (
    <header className="sticky top-0 z-40 border-b border-neutral-800 bg-neutral-950/85 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 h-14 flex items-center gap-2 sm:gap-6">
        <NavLink to="/" className="flex items-center gap-2 shrink-0" data-testid="brand-link">
          <div className="w-7 h-7 rounded-md grid place-items-center bg-[#b6ff2e] text-black">
            <Goal size={17} />
          </div>
          <span className="font-display font-bold uppercase tracking-wide text-sm sm:text-base hidden sm:inline">{t("common.appName")}</span>
        </NavLink>

        <nav className="flex items-center gap-1 overflow-x-auto no-scrollbar flex-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={l.testid}
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium whitespace-nowrap transition-colors ${
                  isActive ? "bg-[#b6ff2e] text-black" : "text-neutral-400 hover:text-neutral-100 hover:bg-neutral-900"
                }`
              }>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <button data-testid="how-scoring-link" onClick={() => setHowOpen(true)}
          className="hidden sm:flex items-center gap-1.5 text-xs text-neutral-400 hover:text-[#b6ff2e] transition-colors">
          <HelpCircle size={15} /> {t("common.howScoringWorks")}
        </button>

        <div className="hidden md:flex items-center gap-2 px-2.5 py-1 rounded-full bg-neutral-900 border border-neutral-800">
          <span className="w-2 h-2 rounded-full bg-[#b6ff2e]" />
          <span className="text-[11px] text-neutral-300" data-testid="active-profile-label">{profileLabel}</span>
        </div>
      </div>
      <HowScoringModal open={howOpen} onOpenChange={setHowOpen} />
    </header>
  );
}
